// Reports WebSocket disconnect/reconnect events to the LiveView server
// for telemetry tracking. Also updates the ws-status-badge visual indicator.
import { t } from "../i18n.js"
export default {
  mounted() {
    const dot = document.getElementById("ws-dot")
    const label = document.getElementById("ws-label")
    const badge = document.getElementById("ws-status-badge")

    const setConnected = () => {
      if (dot) {
        dot.classList.remove("bg-red-400", "bg-yellow-400")
        dot.classList.add("bg-[var(--accent-primary)]", "animate-pulse")
      }
      if (label) label.textContent = t("Live")
      if (badge) {
        badge.classList.remove("text-red-500", "bg-red-500/10", "border-red-500/20")
        badge.classList.add(
          "text-[var(--accent-primary)]",
          "bg-[var(--accent-primary)]/10",
          "border-[var(--accent-primary)]/20"
        )
      }
    }

    const setDisconnected = () => {
      if (dot) {
        dot.classList.remove("bg-[var(--accent-primary)]", "animate-pulse")
        dot.classList.add("bg-red-400")
      }
      if (label) label.textContent = t("Offline")
      if (badge) {
        badge.classList.remove(
          "text-[var(--accent-primary)]",
          "bg-[var(--accent-primary)]/10",
          "border-[var(--accent-primary)]/20"
        )
        badge.classList.add("text-red-500", "bg-red-500/10", "border-red-500/20")
      }
    }

    window.addEventListener("phx:disconnect", () => {
      setDisconnected()
      this.pushEvent("ws_disconnected", { ts: Date.now() })
    })

    window.addEventListener("phx:reconnect", () => {
      setConnected()
      this.pushEvent("ws_reconnected", { ts: Date.now() })
    })
  }
}
